/* eslint-disable no-param-reassign */
import { PayloadAction, createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

interface VideoAssetGroupState {
  assetGroup: {
    uuid: string
    tmpId: string
    name: string
    audio: any
    video: any
    subTitles: any
    mediaProfile: string
    isIntegrated: boolean
    multiAsset: boolean
    veService: boolean
    useFormData?: boolean
    csvData?: any
  }
  assetGroupType: string
  activeTab: number
  isFetchValidated: boolean
  isPreviewed: boolean
  isTranscoded: boolean
  existingSubtitle?: any
  assetgroupLanguageInfo?: any
  liveAttributes?: any
}

const initialState: VideoAssetGroupState = {
  assetGroup: {
    uuid: '',
    tmpId: '',
    name: '',
    audio: [],
    video: [],
    subTitles: [],
    mediaProfile: '',
    isIntegrated: false,
    multiAsset: false,
    veService: false,
    useFormData: false,
    csvData: [],
  },
  assetGroupType: '',
  activeTab: 1,
  isFetchValidated: false,
  isPreviewed: false,
  isTranscoded: false,
  liveAttributes: [],
}

const videoAssetGroupSlice = createSlice({
  name: 'videoAssetGroup',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    resetAssetGroupDetails: (state: any, _action: PayloadAction<any>) => {
      state.assetGroup = {
        ...state.assetGroup,
        uuid: '',
        tmpId: '',
        name: '',
        audio: [],
        video: [],
        subTitles: [],
        mediaProfile: '',
        isIntegrated: false,
        multiAsset: false,
        veService: false,
        assetType: '',
        contentId: null,
        liveAutomationUrl: '',
        liveAutomationDetails: [],
        csvFileSize: null,
        useFormData: false,
      }
      state.assetGroupType = ''
      state.activeTab = 1
      state.isFetchValidated = false
      state.isPreviewed = false
      state.isTranscoded = false
      state.liveAttributes = []
    },
    setAssetGroupDetails: (state: any, action: PayloadAction<any>) => {
      const { payload } = action
      state.assetGroup = {
        ...state.assetGroup,
        uuid: payload?._id || '',
        tmpId: payload?.assetGroupId || '',
        name: payload?.assetGroupName || '',
        audio: payload?.audio || [],
        video: payload?.video || [],
        subTitles: payload?.subTitles || [],
        mediaProfile: payload?.mediaProfile || '',
        isIntegrated: payload?.isIntegrated || false,
        veService: payload?.veService || false,
        multiAsset: payload?.multiAsset || false,
        assetType: payload?.assetType,
        contentId: payload?.contentVersionId,
        liveAutomationUrl: payload?.liveAutomationUrl || '',
        liveAutomationDetails: payload?.liveAutomationDetails || [],
        csvFileSize: payload?.csvFileSize || null,
        useFormData: payload?.useFormData || false,
        csvData: payload?.csvData || [],
      }
    },
    setAssetGroupLanguage: (state: any, action: PayloadAction<any>) => {
      state.assetgroupLanguageInfo = action.payload
    },
    setAssetGroupType: (state: any, action: PayloadAction<any>) => {
      const { payload = '' } = action
      state.assetGroupType = payload
    },

    setAssetGroupActiveTab: (state: any, action: PayloadAction<any>) => {
      const { payload = '' } = action
      state.activeTab = payload
    },
    setAssetGroupIsFetchValidate: (state: any, action: PayloadAction<any>) => {
      const { payload = false } = action
      state.isFetchValidated = payload
    },
    setAssetGroupIsPreviewed: (state: any, action: PayloadAction<any>) => {
      const { payload = false } = action
      state.isPreviewed = payload
    },
    setAssetGroupIsTranscoded: (state: any, action: PayloadAction<any>) => {
      const { payload = false } = action
      state.isTranscoded = payload
    },
    setExistingSubtitlesSlice: (state: any, action: PayloadAction<any>) => {
      state.existingSubtitle = action.payload
    },
    setLiveAttributes: (state: any, action: PayloadAction<any>) => {
      state.liveAttributes = action.payload
    },
  },
})

export const {
  resetAssetGroupDetails,
  setAssetGroupDetails,
  setAssetGroupType,
  setAssetGroupActiveTab,
  setAssetGroupIsFetchValidate,
  setAssetGroupIsPreviewed,
  setAssetGroupIsTranscoded,
  setExistingSubtitlesSlice,
  setAssetGroupLanguage,
  setLiveAttributes,
} = videoAssetGroupSlice.actions

const videoAssetGroupSelector = (state: { videoAssetGroup: VideoAssetGroupState }) =>
  state.videoAssetGroup

export const selectAssetGroupDetails = createSelector(
  videoAssetGroupSelector,
  (state) => state.assetGroup,
)

export const selectAssetGroupType = createSelector(
  videoAssetGroupSelector,
  (state) => state.assetGroupType,
)

export const selectAssetGroupActiveTab = createSelector(
  videoAssetGroupSelector,
  (state) => state.activeTab,
)

export const selectAssetGroupIsFetchValidated = createSelector(
  videoAssetGroupSelector,
  (state) => state.isFetchValidated,
)

export const selectAssetGroupIsPreviewed = createSelector(
  videoAssetGroupSelector,
  (state) => state.isPreviewed,
)

export const selectAssetGroupIsTranscoded = createSelector(
  videoAssetGroupSelector,
  (state) => state.isTranscoded,
)
export const existingSubtitleRedux = createSelector(
  videoAssetGroupSelector,
  (state) => state.existingSubtitle,
)
export const assetGroupInfoForLanguage = createSelector(
  videoAssetGroupSelector,
  (state) => state.assetgroupLanguageInfo,
)
export const selectLiveAttributes = createSelector(
  videoAssetGroupSelector,
  (state) => state.liveAttributes,
)
export const getMediaProfileList = createAsyncThunk(
  'videoAssetGroup/getMediaProfileList',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData = API_CONFIG(
      API_LIST.SYSTEM_CONFIGURATION.MASTER_LIST,
      {},
      null,
      'keyName=MEDIA_PROFILE,TRANSCODING_PROCESS_TYPE',
    )
    const result: any = await mainApiService(requestedData)
    dispatch(setLoader(false))
    const mediaProfileCopy: any = []
    const transcodingProcessCopy: any = []
    let tempObj: any = {}
    if (result?.responseCode === 200) {
      result?.data?.forEach((item: any) => {
        if (item.configKey === 'MEDIA_PROFILE') {
          item.configValue.forEach((ele: any) => {
            mediaProfileCopy.push({ key: ele?.key, value: ele?.value, id: ele?.key })
          })
        }
        if (item.configKey === 'TRANSCODING_PROCESS_TYPE') {
          item.configValue.forEach((obj: any) => {
            transcodingProcessCopy.push({ key: obj?.key, value: obj?.value, id: obj?.key })
          })
        }
      })
    }
    tempObj = { media: mediaProfileCopy, process: transcodingProcessCopy }
    return tempObj
  },
)

export const createAssetGroup = createAsyncThunk(
  'videoAssetGroup/createAssetGroup',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.CREATE_ASSET_GROUP,
      payload?.reqPayload,
      null,
      null,
      {
        'x-last-updated-time': new Date(payload?.updatedAt).getTime() || '',
        'x-failed-user-override': payload?.contentId || '',
        'x-failed-user-override-version': payload?.reqPayload?.contentId || '',
      },
    )

    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const getAssetGroupDetails = createAsyncThunk(
  'videoAssetGroup/getAssetGroup',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(API_LIST.VIDEO_CONTENT_TYPE.DETAIL_ASSET_GROUP, null, {
      contentVersionId: payload?.contentId,
      assetGroupId: payload?.assetGroupTmpId,
    })
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const getAssetGroupsList = createAsyncThunk(
  'videoAssetGroup/getAssetGroup',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(API_LIST.VIDEO_CONTENT_TYPE.LIST_ASSET_GROUPS, null, null, {
      assetGroupId: payload?.assetGroupTmpId,
      isLiveAutomation: 'true',
    })
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const getSubtitleDataService = createAsyncThunk(
  'videoAssetGroup/getSubtitle',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(API_LIST.HOMEPAGE_ROUTE.GET_SUBTITLE_DATA, null, {
      contentVersionId: payload,
    })
    const data: any = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)
export const updateAssetGroup = createAsyncThunk(
  'videoAssetGroup/updateAssetGroup',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.UPDATE_ASSET_GROUP,
      payload?.reqPayload,
      { assetGroupId: payload?.reqPayload?.assetGroupId },
      null,
      {
        'x-last-updated-time': new Date(payload?.updatedAt).getTime() || '',
        'x-failed-user-override': payload?.contentId || '',
        'x-failed-user-override-version': payload?.reqPayload?.contentId || '',
      },
    )
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)
export const updoadSubtitleService = createAsyncThunk(
  'videoAssetGroup/uploadSubtitle',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.HOMEPAGE_ROUTE.UPLOAD_SUBTITLE,
      payload,
      null,
      null,
      {
        'x-failed-user-override': payload?.contentId || '',
        'x-failed-user-override-version': payload?.contentVersionId || '',
      },
    )
    const data: any = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export const deleteGroupService = createAsyncThunk(
  'videoAssetGroup/deleteAssetGroup',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.UNLINK_ASSET_GROUP,
      payload?.payload,
      null,
      null,
      {
        'x-last-updated-time': new Date(payload?.updatedAt).getTime() || '',
      },
    )

    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const workflowStatusService = createAsyncThunk(
  'videoAssetGroup/workflowStatus',
  async (payload: any) => {
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.LATEST_ASSET_GROUP_STATUS,
      null,
      null,
      payload,
    )
    const data: any = await mainApiService(APIRequest)
    return data
  },
)

export const fetchAndValidateService = createAsyncThunk(
  'videoAssetGroup/fetchValidate',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.VALIDATE_ASSET_GROUP,
      payload?.payload,
      null,
      null,
      {
        'x-last-updated-time': new Date(payload?.updatedAt).getTime() || '',
      },
    )
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const previewService = createAsyncThunk(
  'videoAssetGroup/previewVideo',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.INITIATE_PREVIEW,
      payload?.payload,
      null,
      null,
      {
        'x-last-updated-time': new Date(payload?.updatedAt).getTime() || '',
      },
    )
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const transcodingService = createAsyncThunk(
  'videoAssetGroup/transcoding',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.INITIATE_TRANSCODE,
      payload?.payload,
      null,
      null,
      { 'x-last-updated-time': new Date(payload?.updatedAt).getTime() || '' },
    )
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const getDRMPreviewURL = createAsyncThunk(
  'videoAssetGroup/getDRMPreviewURL',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(API_LIST.VIDEO_CONTENT_TYPE.PREVIEW_URL, null, null, payload)
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const getDRMTypeService = createAsyncThunk(
  'videoAssetGroup/getDRMType',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.TRANSACTION_INPUT_DETAILS,
      null,
      {
        contentId: payload?.contentVersionId,
      },
    )
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export const cancelPreviewTranscoding = createAsyncThunk(
  'videoAssetGroup/cancelPreviewTranscoding',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const APIRequest: any = API_CONFIG(
      API_LIST.VIDEO_CONTENT_TYPE.CANCEL_TRANSCODING,
      payload?.payload,
      null,
      null,
      {
        'x-last-updated-time': new Date(payload?.updatedAt).getTime() || '',
      },
    )
    const data: any = await mainApiService(APIRequest)
    dispatch(setLoader(false))
    return data
  },
)

export default videoAssetGroupSlice
